import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = ({ title }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <header className="fixed top-0 md:left-64 left-0 right-0 h-16 bg-white border-b border-slate-200 z-30 flex items-center justify-between px-6 shadow-sm">
      <div className="flex items-center gap-4">
        {location.pathname !== "/" && (
          <Link
            to="/"
            className="flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-indigo-600 transition"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Kembali
          </Link>
        )}
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-indigo-600 rounded-full"></span>
          <h1 className="text-lg font-bold text-slate-900">{title}</h1>
        </div>
      </div>
      <div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-sm font-semibold text-rose-600 hover:text-rose-700 transition"
        >
          <svg
            className="w-4.5 h-4.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2.5"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          Keluar
        </button>
      </div>
    </header>
  );
};

export default Header;
